import { useState, useEffect, useRef } from "react";
import axios from "axios";

function ClientSelector({ onSelect }) {

const [clients,setClients]=useState([]);
const [search,setSearch]=useState("");

const [selectedIndex,
setSelectedIndex]=useState(-1);

const searchInputRef=useRef(null);

const loadClients=async()=>{

try{

const token=
localStorage.getItem("token");

const response=
await axios.get(

"https://saleupcall.com/api/Client/get-clients.php",

{
headers:{
Authorization:
`Bearer ${token}`
}
}

);

if(response.data.status){

setClients(
response.data.data || []
);

}

}
catch(error){

console.log(error);

}

};

useEffect(()=>{

loadClients();

},[]);

useEffect(()=>{

const timer=
setTimeout(()=>{

searchInputRef.current?.focus();

},200);

return()=>clearTimeout(timer);

},[]);


// Search se matching row select

useEffect(()=>{

if(search===""){

setSelectedIndex(-1);

return;

}

const index=

clients.findIndex(

client=>

(client.company_name || "")
.toLowerCase()
.startsWith(
search.toLowerCase()
)

);

setSelectedIndex(index);

},[search,clients]);

return(

<>

<input

ref={searchInputRef}

type="text"

className="form-control mb-2"

placeholder="Search Client"

value={search}

onChange={(e)=>
setSearch(
e.target.value
)
}

onKeyDown={(e)=>{

// Down arrow

if(e.key==="ArrowDown"){

e.preventDefault();

setSelectedIndex((prev)=>{

if(prev===-1){

return 0;

}

return Math.min(
prev+1,
clients.length-1
);

});

}


// Up arrow

if(e.key==="ArrowUp"){

e.preventDefault();

setSelectedIndex((prev)=>{

return Math.max(
prev-1,
0
);

});

}


// Enter

if(
e.key==="Enter"
&&
clients[selectedIndex]
){

e.preventDefault();

onSelect({

id:
clients[selectedIndex].id,

name:
clients[selectedIndex]
.company_name

});

}

}}

style={{
caretColor:"black"
}}

/>


<div
style={{
maxHeight:"400px",
overflow:"auto"
}}
>

<table
className="table table-bordered table-hover table-sm"
>

<thead
className="table-success"
>

<tr>

<th>ID</th>
<th>Company</th>
<th>Contact Person</th>
<th>Mobile</th>

</tr>

</thead>

<tbody>

{

clients.map(

(client,index)=>(

<tr

key={client.id}

className={
index===selectedIndex
?
"table-primary"
:
""
}

style={{
cursor:"pointer"
}}

onClick={()=>{

setSelectedIndex(index);

onSelect({

id:client.id,
name:client.company_name

});

}}

>

<td>{client.id}</td>

<td>
{client.company_name}
</td>

<td>
{client.contact_person}
</td>

<td>
{client.mobile}
</td>

</tr>

)

)

}

</tbody>

</table>

</div>

</>

);

}

export default ClientSelector;